"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldLog = exports.isValidLogLevel = exports.PREFIX = void 0;
exports.PREFIX = "log-level";
const WORD_LEVEL_LOOKUP = {
    TRACE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 5,
    ERROR: 6,
    FATAL: 9,
};
const isValidLogLevel = (logLevel) => Object.keys(WORD_LEVEL_LOOKUP).includes(logLevel.toUpperCase());
exports.isValidLogLevel = isValidLogLevel;
const shouldLog = ({ loggerName, desiredLevel, defaultLevel, get, }) => {
    let loggerNameWithPrefix = `${exports.PREFIX}.${loggerName}`;
    const desiredLevelNumber = WORD_LEVEL_LOOKUP[desiredLevel.toUpperCase()];
    while (loggerNameWithPrefix.length > 0) {
        const resolvedLevel = get(loggerNameWithPrefix);
        if (resolvedLevel !== undefined) {
            return WORD_LEVEL_LOOKUP[resolvedLevel.toString()] <= desiredLevelNumber;
        }
        if (loggerNameWithPrefix.indexOf(".") === -1) {
            break;
        }
        loggerNameWithPrefix = loggerNameWithPrefix.slice(0, loggerNameWithPrefix.lastIndexOf("."));
    }
    return WORD_LEVEL_LOOKUP[defaultLevel.toUpperCase()] <= desiredLevelNumber;
};
exports.shouldLog = shouldLog;
